export default "* Fest\n* Ceremoni";